import { render } from "./Sections.vue?vue&type=template&id=cf1bea6e&ts=true"
import script from "./Sections.vue?vue&type=script&lang=ts"
export * from "./Sections.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/local/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__